import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import I18n from 'I18n';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UICopyButton from 'UIComponents/button/UICopyButton';
import { FormattedMessage } from '../../../components/I18n';
import { COURSE_OVERVIEW_URL_FRAGMENT, LESSON_OVERVIEW_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT } from '../../../constants/Navigation';
import { buildReferralLink } from '../../../utils/RoutingUtils';
import UsageTracker from '../../../utils/UsageTracker';
import { useUserInfo } from '../../accounts';
import { useUserOwnsPlaylist } from '../../savedItems';
export const ShareButton = ({
  onClick,
  playlistId,
  trackId,
  lessonId,
  language,
  render = button => button
}) => {
  const {
    userInfo
  } = useUserInfo();
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  const userId = Number(userInfo && userInfo.user.id);
  let link;

  if (playlistId) {
    link = buildReferralLink(PLAYLIST_URL_FRAGMENT.replace(':playlistId', playlistId.toString()), userId);
  } else if (lessonId) {
    link = buildReferralLink(`${LESSON_OVERVIEW_URL_FRAGMENT}/${lessonId}${language ? `/${language}` : null}`, userId);
  } else if (trackId) {
    link = buildReferralLink(`${COURSE_OVERVIEW_URL_FRAGMENT}/${trackId}${language ? `/${language}` : null}`, userId);
  }

  if (!link) return null;

  const trackTrackLessonShare = () => {
    UsageTracker.track('interaction', {
      action: 'share-track-lesson',
      trackId,
      lessonId,
      language,
      location: 'card-menu'
    });
  };

  const trackPlaylistShare = () => {
    UsageTracker.track('playlistInteraction', {
      action: 'share-playlist',
      isOwner: userIsOwner,
      playlistId,
      location: 'card-menu'
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: render( /*#__PURE__*/_jsxs(UICopyButton, {
      onClick: () => {
        FloatingAlertStore.addAlert({
          type: 'success',
          message: I18n.text('learningCenter.shareThis.notification')
        });
        if (playlistId) trackPlaylistShare();else trackTrackLessonShare();
        onClick();
      },
      style: {
        width: '100%'
      },
      tooltipPlacement: "right",
      use: "unstyled",
      value: link,
      children: [playlistId && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.savedItems.sharePlaylist"
      }), trackId && !lessonId && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.savedItems.shareTrack"
      }), lessonId && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.savedItems.shareLesson"
      })]
    }))
  });
};
export default ShareButton;